<template>
  <header class="nav-logo">
    <div v-if="notMobile" style="display: flex; cursor: pointer">
      <img
        class="logo"
        src="../../icons/svg/cosmoplat.svg"
        style="width: auto; height: 42px"
        @click="goCosmo"
      />
      <div
        style="
          width: 1px;
          height: 100%;
          background-color: #ddd;
          margin-left: 13px;
          margin-right: 13px;
        "
      ></div>
      <img
        class="logo"
        src="../../icons/svg/haimozhiyun.svg"
        style="width: auto; height: 28px; margin: auto"
        @click="goPortal"
      />
    </div>
    <div v-if="!notMobile" id="btn" class="menuIcon" @click="openMenu">
      <i class="el-icon-s-unfold"></i>
    </div>
    <!--   <div v-if="!notMobile" id="test" class="NavMenuvertical">
	   <NavMenu mode="vertical" />
   </div> -->
    <div class="search-group">
      <el-select v-model="selectType" class="input-pre">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <!-- <div class="input-pre">Products</div> -->
      <el-input
        v-model="searchKey"
        size="medium"
        placeholder=""
        class="input-search"
      >
      </el-input>
      <el-button
        size="mini"
        type="primary"
        class="search-btn"
        icon="el-icon-search"
        @click="searchInfo"
        >Search</el-button
      >
    </div>
  </header>
</template>

<script>
import "./_NavLogo.scss";
import NavMenu from "../NavMenu/NavMenu";
import bus from "../../utils/eventBus";
export default {
  name: "NavLogo",
  components: {
    // NavMenu
  },
  props: {},
  data() {
    return {
      searchKey: "",
      selectType: 0,
      options: [
        {
          label: "Products",
          value: 0,
        },
        {
          label: "Suppliers",
          value: 1,
        },
      ],
      isOpenMenu: false,
    };
  },
  computed: {
    notMobile() {
      return !this.$store.state.isMobile;
    },
  },
  methods: {
    openMenu() {
      bus.$emit("setOpenStatus", true);
      //  if (this.isOpenMenu) {
      // // this.$store.commit("setOpenMenuStatus", false);
      // bus.$emit("setOpenStatus",this.isOpenMenu)
      // this.isOpenMenu=false
      //  } else {
      //   bus.$emit("setOpenStatus",this.isOpenMenu)
      // // this.$store.commit("setOpenMenuStatus", true);
      // this.isOpenMenu=true
      //  }
    },

    searchInfo() {
      this.$store.commit("searchFor", {
        type: this.selectType == 0 ? "Products" : "Suppliers",
        condition: this.searchKey,
      });
      this.$router.push("/search");
    },
    handleCommand(command) {
      if (this.$route.name === command) {
        window.location.reload();
      } else {
        this.$router.push({ name: command });
      }
    },
    goCosmo() {
      window.open("https://www.cosmoplat.com/");
    },
    goPortal() {
      window.location.href = "https://hmzy.cosmoplat.com/";
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../scss/global";
* {
  font-size: 12px;
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #ddd;
}
/deep/ .el-select > .el-input {
  display: block;
}
/deep/ .el-select .el-input__inner:focus {
  border-color: #ddd;
}
</style>
